"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAction = createAction;
function createAction(type, payload) {
    return payload === undefined ? { type } : { type, payload };
}
